/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionStatusEvent
 */
export interface OutputUavMissionStatusEvent {
    /**
     * AuthorName — хто перевів фазу. Порожньо для автоматичних переходів (напр. анімація
     * диспетчерської або Element-бот без прив'язки до користувача).
     * @type {string}
     * @memberof OutputUavMissionStatusEvent
     */
    authorName?: string;
    /**
     * CreatedAt — момент переходу у фазу (RFC3339).
     * @type {string}
     * @memberof OutputUavMissionStatusEvent
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionStatusEvent
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputUavMissionStatusEvent interface.
 */
export function instanceOfOutputUavMissionStatusEvent(value: object): boolean {
    return true;
}

export function OutputUavMissionStatusEventFromJSON(json: any): OutputUavMissionStatusEvent {
    return OutputUavMissionStatusEventFromJSONTyped(json, false);
}

export function OutputUavMissionStatusEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionStatusEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'authorName': json['authorName'] == null ? undefined : json['authorName'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputUavMissionStatusEventToJSON(value?: OutputUavMissionStatusEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authorName': value['authorName'],
        'createdAt': value['createdAt'],
        'status': value['status'],
    };
}

